import { Link } from "react-router-dom";
import { Typography, CssBaseline, Container, Box } from "@mui/material";
import PrimaryButton from "../components/primaryButton";
import "../App.css";

export default function Home() {
  return (
    <>
      <CssBaseline />
      <Container maxWidth={false} minheight={"95vh"}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            backgroundImage: "url('items.jpg')",
            backgroundSize: 'cover',
            height: '92vh'
          }}
        >
          <Box
            sx={{
              padding: "2rem",
              backgroundColor: "rgb(156, 39, 176, 0.6)",
              display: "flex",
              alignItems: "center",
              marginBottom: "4rem",
            }}
          >
            <Typography
              sx={{ color: 'white', typography: { md: "h1", xs: "h2" }, paddingY: { xs: 1 } }}
            >
              Find Everything, Anytime, Anywhere
            </Typography>
          </Box>

          <Link to="/products">
            <PrimaryButton val={"Browse Products"} />
          </Link>
        </Box>
      </Container>
    </>
  );
}
